export const ROADMAP_TEMPLATE_CLIPBOARD_KEY = 'bba-roadmap-template-clipboard-v1';

export function formatDateForInput(dateValue) {
  if (!dateValue) return '';
  if (dateValue.toDate) {
    return dateValue.toDate().toISOString().split('T')[0];
  }
  if (dateValue instanceof Date) {
    return dateValue.toISOString().split('T')[0];
  }
  if (typeof dateValue === 'string') {
    const date = new Date(dateValue);
    if (!isNaN(date.getTime())) {
      return date.toISOString().split('T')[0];
    }
    return dateValue.slice(0, 10);
  }
  return '';
}

export function mergeTemplateWithEditForm(template, editForm, isEditing) {
  if (!template) return null;
  if (!isEditing) return { ...template };
  return {
    ...template,
    ...editForm,
  };
}

export function buildClipboardSnapshot(template, editForm, isEditing) {
  const merged = mergeTemplateWithEditForm(template, editForm, isEditing);
  const payload = {
    title: merged.title ?? '',
    description: merged.description ?? '',
    department: merged.department ?? '',
    emoji: merged.emoji ?? '',
    navigators: Array.isArray(merged.navigators)
      ? merged.navigators.map((n) => ({
          name: n?.name ?? '',
          role: n?.role ?? '',
        }))
      : [],
    tasks: (merged.tasks || []).map((t, index) => ({
      title: t.title ?? '',
      description: t.description ?? '',
      courseId: t.courseId ?? '',
      courseTitle: t.courseTitle ?? '',
      portalPage: t.portalPage ?? '',
      externalLink: t.externalLink ?? '',
      callBookingDepartment: t.callBookingDepartment ?? '',
      order: t.order ?? index + 1,
      completed: !!t.completed,
      files: Array.isArray(t.files) ? JSON.parse(JSON.stringify(t.files)) : [],
      dueDate: t.dueDate ?? null,
      assignees: Array.isArray(t.assignees) ? JSON.parse(JSON.stringify(t.assignees)) : [],
      status: t.status ?? 'Not Done',
    })),
  };
  return { version: 1, copiedAt: Date.now(), payload };
}

export function readClipboardSnapshot() {
  try {
    // localStorage is shared across tabs on the same origin; sessionStorage is not.
    const raw =
      localStorage.getItem(ROADMAP_TEMPLATE_CLIPBOARD_KEY) ||
      sessionStorage.getItem(ROADMAP_TEMPLATE_CLIPBOARD_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.version !== 1 || !data.payload) return null;
    return data;
  } catch {
    return null;
  }
}

export function writeClipboardSnapshot(snapshot) {
  const json = JSON.stringify(snapshot);
  localStorage.setItem(ROADMAP_TEMPLATE_CLIPBOARD_KEY, json);
  try {
    sessionStorage.removeItem(ROADMAP_TEMPLATE_CLIPBOARD_KEY);
  } catch {
    // ignore
  }
}

export function applyClipboardPayloadToTemplate(targetTemplate, payload) {
  const tasks = (payload.tasks || []).map((t, idx) => ({
    ...t,
    id: Date.now() + idx + Math.floor(Math.random() * 100000),
    order: t.order ?? idx + 1,
    files: Array.isArray(t.files) ? t.files : [],
    assignees: Array.isArray(t.assignees) ? t.assignees : [],
  }));

  return {
    ...targetTemplate,
    title: payload.title ?? '',
    description: payload.description ?? '',
    department: payload.department ?? targetTemplate.department,
    order: targetTemplate.order ?? targetTemplate.allOrder ?? 1,
    emoji: payload.emoji ?? '',
    status: 'not-started',
    dateStarted: null,
    dateCompleted: null,
    navigators: Array.isArray(payload.navigators) ? payload.navigators.map((n) => ({ ...n })) : [],
    tasks,
    id: targetTemplate.id,
  };
}
